// extracted by mini-css-extract-plugin
export default {"root":"ErrorBody_root__a4Z-U","body":"ErrorBody_body__eoL0L","img":"ErrorBody_img__ruSsp","fill":"ErrorBody_fill__yQJqN"};